
import { Outlet } from "react-router-dom"
import AdminHeader from './Header-admin'

export default function Layout() {
    return(
        <div className="site-wrapper">
            <AdminHeader />
            <Outlet />
        </div>
    )
}